<template>
	<div class="LoadingBox NoSelect">
	  <div class="LoadingMain" :style="{marginTop:boxTop+'px'}">
	    <div class="LoadingIcon"><img src="../../../static/images/loading3.gif"></div>
	  </div>
	</div>
</template>

<script>
export default {
  name: 'Loading',
  data () {
    return {
      boxTop:100
    }
  },
  created () {
    this.boxTop = document.documentElement.clientHeight/2 - 97;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Loading.vue